import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-grupo-create-timeline',
  templateUrl: './grupo-create-timeline.component.html',
  styleUrls: ['./grupo-create-timeline.component.css']
})
export class GrupoCreateTimelineComponent implements OnInit {

  @Input() step: number;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  redirect(route: string, pos: number) {
    if (this.step >= pos) {
      this.router.navigate([route]);
    }
  }

}
